import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@monorepo-apps/ui/src/components/select";

import { StatusDot } from "@/presentation/components/status/status-dot";
import {
  DELIVERY_STATUS_LABEL,
  DELIVERY_STATUS_ORDER,
  DELIVERY_STATUS_TONE,
} from "@/presentation/data/board";
import type { DeliveryStatus } from "@/infrastructure/supabase/database.types";

interface StatusSelectProps {
  value: DeliveryStatus;
  onChange: (next: DeliveryStatus) => void;
  /** "default" = bordered standalone control; "cell" = borderless inline table cell. */
  variant?: "default" | "cell";
  disabled?: boolean;
}

export function StatusSelect({
  value,
  onChange,
  variant = "default",
  disabled = false,
}: StatusSelectProps) {
  const triggerClass =
    variant === "cell"
      ? "h-8 w-full justify-between gap-2 border-transparent bg-transparent px-2 hover:border-border hover:bg-muted/40"
      : "h-9 w-[156px] gap-2 px-3";
  return (
    <Select value={value} onValueChange={(v) => onChange(v as DeliveryStatus)} disabled={disabled}>
      <SelectTrigger
        className={`font-data text-[12px] [&>span]:line-clamp-none ${triggerClass}`}
        onClick={(e) => e.stopPropagation()}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {DELIVERY_STATUS_ORDER.map((status) => (
          <SelectItem key={status} value={status} className="text-[13px]">
            <span className="flex items-center gap-2">
              <StatusDot tone={DELIVERY_STATUS_TONE[status]} size="md" />
              {DELIVERY_STATUS_LABEL[status]}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
